<template>
    <!-- @touchmove.prevent,可以在遮罩层中添加 @touchmove.prevent 就可以实现禁止页面滚动,注意 弹窗里面有滚动条的也是无法滚动的 -->
    <div class="shipping-main">
        <div class="shipping-mask" @click="addressPopupCloseFun"></div>
        <div class="context" @click.stop="() => {}">
            <img
                class="bgImg"
                src="@/assets/Image/address-bg.png"
            />
            <img
                class="close"
                @click="addressPopupCloseFun"
                src="@/assets/icon/close-icon.png"
                alt=""
            />
            <div class="context-from">
                <div class="from-lable-input">
                    <div class="inputInfo">
                        <div class="lable-p">收件人</div>
                        <div class="from-input-border">
                            <input
                                type="text"
                                key="name"
                                class="from-input"
                                v-model="option.name"
                                placeholder="请填写收件人姓名"
                            />
                        </div>                       
                    </div>
                    <div class="inputInfo">
                        <div class="lable-p">联系电话</div>
                        <div class="from-input-border">
                            <input
                                type="text"
                                key="phone"
                                class="from-input"
                                v-model="option.phone"
                                placeholder="请填写联系电话"
                            />
                        </div> 
                    </div>
                    <div class="inputInfo">
                        <div class="lable-p">省市区</div>
                        <div class="select-address-icon-box" @click="actionSheetState = true">
                            <div class="select-address-p" v-if="option.provinces">{{ option.provinces }}</div>
                            <div class="select-address-p p-default" v-else>所在地区</div>
                            <img
                                src="@/assets/icon/address-icon.png"
                                class="select-address-icon"
                            />
                        </div>
                    </div>
                    <div class="inputInfo">
                        <div class="lable-p">详细地址</div>
                        <div class="from-input-border">
                            <input
                                 type="text"
                                key="site"
                                class="from-input"
                                v-model="option.site"
                                placeholder="请填写详细地址"
                            />
                        </div> 
                    </div>
                </div>                
                <div class="attention">联系方式用于快递，售后等服务，请仔细核对</div>
                <div @click="submitFun()" class="btn">提交</div>
            </div>           
        </div>   
        <!-- 选择省份和城市弹窗 -->
        <van-action-sheet v-model="actionSheetState">
            <van-area :area-list="areaList" :columns-num="columnsNum" :value="actionSheetValue" @confirm="areaListConfirm" @cancel="areaListCancel" />
        </van-action-sheet>
    </div>
</template>

<script>
import { areaListApi } from "@/api/index.js";
export default {
    name: "shipping",
    data() {
        return {
            option: {
                name: "",
                phone: "",
                provinces: "",
                site: "",
                provincesCode: [],
                provincesName: [],
            },
            areaApiData: [],        //省市区接口数据
            actionSheetState: false,		//省份城市选择的外层弹窗状态
            actionSheetValue: '',       //默认省份选择的值
            columnsNum: 3,		//省份城市选择的列数
            areaList: {
                province_list: {},
                city_list: {},
                county_list: {},
            }
        };
    },
    created() {
        this.getAreaList();
        this.getLocaStrogFun();
    },
    methods: {
        getLocaStrogFun() {
            let address_yuixin = window.localStorage.getItem("address_yuixin");
            if (address_yuixin) {
                this.option.name = JSON.parse(address_yuixin).name;
                this.option.phone = JSON.parse(address_yuixin).phone;
                this.option.site = JSON.parse(address_yuixin).site;
                this.option.provincesCode[0] =
                    JSON.parse(address_yuixin).provincesCode[0];
                this.option.provincesCode[1] =
                    JSON.parse(address_yuixin).provincesCode[1];
                this.option.provincesCode[2] =
                    JSON.parse(address_yuixin).provincesCode[2];

                this.option.provincesName[0] =
                    JSON.parse(address_yuixin).provincesName[0];
                this.option.provincesName[1] =
                    JSON.parse(address_yuixin).provincesName[1];
                this.option.provincesName[2] =
                    JSON.parse(address_yuixin).provincesName[2];  

                this.option.provinces = this.option.provincesName[0] + '-' + this.option.provincesName[1] + '-' + this.option.provincesName[2];
            }
        },
        getAreaList() {
            let self = this;
            //使用接口数据
            areaListApi().then((res) => {
                if(res.code == 200){
                    self.areaApiData = res.data.data;   //省市区接口数据
                    //根据后台接口数据处理省市区数据
                    self.processAreaData();
                }else{
                    self.$toast(res.msg || '服务器请求错误')
                }
            }); 
        },
        //根据后台接口数据处理省市区数据
        processAreaData(){
            let self = this;
            //获取当前省市
            let AreaList = {
                province_list: {},
                city_list: {},
                county_list: {},
            };
            self.areaApiData.forEach((province) => {
                AreaList.province_list[province.dict_value] = province.dict_label; 
                if(province.child && province.child.length > 0)province.child.forEach((city) => {
                    AreaList.city_list[city.dict_value] = city.dict_label;
                    if(city.child && city.child.length > 0)city.child.forEach((county) => {
                        AreaList.county_list[county.dict_value] = county.dict_label;
                        //判断当前省份是否是选中的
                        if(self.option.provincesName[0] == province.dict_label && self.option.provincesName[1] == city.dict_label && self.option.provincesName[2] == county.dict_label){
                            self.actionSheetValue = county.dict_value;   
                            console.log(self.actionSheetValue); 
                        }
                    });
                });
            });
            self.areaList = AreaList;
            console.log(self.areaList);
        },
        //选择省份和城市-确实事件
        areaListConfirm(arr){
            let self = this; 
            // console.log(arr);
            self.option.provincesName[0] = arr[0].name;
            self.option.provincesName[1] = arr[1].name;
            self.option.provincesName[2] = arr[2].name;  
            self.option.provinces = self.option.provincesName[0] + '-' + self.option.provincesName[1] + '-' + self.option.provincesName[2];
            //循环省市区数据，获取对应的code值
            self.areaApiData.forEach((province) => {
                if(province.dict_label == self.option.provincesName[0]){
                    self.option.provincesCode[0] = province.dict_code;
                    if(province.child && province.child.length > 0)province.child.forEach((city) => {
                        if(city.dict_label == self.option.provincesName[1]){
                            self.option.provincesCode[1] = city.dict_code;
                            if(city.child && city.child.length > 0)city.child.forEach((county) => {
                                if(county.dict_label == self.option.provincesName[2]){
                                    self.option.provincesCode[2] = county.dict_code;
                                }
                            });
                        }
                    });
                }
            });
            self.actionSheetState = false;
        },
        //选择省份和城市-取消事件
        areaListCancel(){
            this.actionSheetState = false;
        },        
        //提交
        submitFun() {
            var reg =
                /^((13\d)|(14[5,7,9])|(15[0-3,5-9])|(166)|(17[0,1,3,5,7,8])|(18[0-9])|(19[8,9]))\d{8}/;
            if (!this.option.name) return this.$toast("请填写姓名");
            if (!this.option.phone) return this.$toast("请填写手机号");
            if (!reg.test(this.option.phone))
                return this.$toast("手机号码格式错误");
            if (!this.option.provinces) return this.$toast("请选择省市区");
            if (!this.option.site) return this.$toast("请填写详细地址");
            this.$emit("submit", this.option);
            // console.log(this.option);
        },
        //地址弹窗关闭
        addressPopupCloseFun() {
            this.$emit("addressPopupClose");
        },
    },
};
</script>

<style lang="less" scoped>
.shipping-main {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    z-index: 999;
    .shipping-mask {
        position: absolute;
        top: 0;bottom: 0;
        left: 0;right: 0;
        z-index: 8;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
    }
    .context {
        position: absolute;
        top: 45%;
        left: 50%;
        z-index: 9;
        transform: translateX(-50%) translateY(-50%);
        width: 320px;
        box-sizing: border-box;
        .bgImg {
            width: 100%;
            display: block;
        }
        .close {
            position: absolute;
            top: 5px;
            right: -12px;
            width: 24px;
            height: 24px;
            display: block;
        }
        .context-from {
            position: absolute;
            top: 110px;
            left: 50%;
            transform: translateX(-50%);
            width: 290px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            .from-lable-input{
                width: 100%;
                padding: 0 15px 15px 15px;
                background-color: #ffffff;
                border-radius: 10px;
                .inputInfo{
                    margin-top: 15px;
                    .lable-p {
                        font-size: 13px;
                        color: #666666;
                        line-height: 18px;
                    }   
                    .from-input-border{
                        margin-top: 5px;
                        width: 100%;
                        background-color: #F4F4F5;
                        border-radius: 6px;
                        .from-input{
                            width: 100%;
                            height: 36px;
                            border: none;
                            box-sizing: border-box;
                            padding: 0 10px;
                            background-color: transparent;
                            font-size: 13px;
                            color: #5E3617;
                            line-height: 36px;
                            letter-spacing: 0;	
                        }                       					
                        .from-input::placeholder{
                            color: #999999;
                        }
                    }  
                    .select-address-icon-box{
                        width: 100%;
                        height: 36px;
                        background-color: #F4F4F5;
                        border-radius: 6px;
                        padding: 0 10px;
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .select-address-p{
                            font-size: 13px;
                            color: #5E3617;
                            line-height: 36px;
                        }
                        .p-default{
                            color: #999999;
                        }
                        .select-address-icon{
                            width: 16px;
                            height: 16px;
                            display: block;
                        }
                    }
                }
            }
            .attention {
                width: 100%;
                font-size: 13px;
                color: rgba(0, 0, 0, 0.3);
                margin-top: 15px;
                text-align: center;   
            }
            .btn {
                margin-top: 10px;
                width: 100%;
                height: 40px;
                border-radius: 20px;
                background-color: #603718;
                color: #F4DD87;
                font-size: 15px;
                font-weight: bold; 
                line-height: 40px;
                text-align: center;              
            }
        }        
        
        
    }
}
</style>
